<template>
  <div class="wbs-login">
    <div class="wbs-login__form">
      <div class="card shadow">
        <div class="card-header">
          <h4 class="text-center">WBS PACS - Manager</h4>
        </div>
        <div class="card-body">
          <b-form @submit.prevent="entrar">
            <b-form-group label-for="chaveAcesso">
              <b-input-group>
                <b-input-group-prepend is-text>
                  <i class="mdi mdi-key"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="chaveAcesso"
                  v-model="chaveAcesso"
                  autocomplete="off"
                  :state="!$v.chaveAcesso.$error"
                  placeholder="Chave de Acesso"
                ></b-form-input>
                <b-form-invalid-feedback>
                  <span v-if="!$v.chaveAcesso.required"
                    >Este Campo &eacute; requerido.</span
                  >
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
            <b-button
              type="submit"
              variant="success"
              :block="true"
              class="text-center"
              >Entrar</b-button
            >
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      chaveAcesso: ""
    };
  },
  validations: {
    chaveAcesso: { required }
  },
  methods: {
    async entrar(e) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        e.preventDefault();
        console.info("Form Invalido");
        return;
      }

      try {
        const chaveAcesso = await this.$store.dispatch("autenticacao/login", {
          chaveAcesso: this.chaveAcesso
        });

        if (chaveAcesso) {
          this.$router.push({ path: "/" });
        }
      } catch (err) {
        this.$store.dispatch("autenticacao/logout").then(() => {
          let msg =
            err && err.response && typeof err.response.data == "string"
              ? err.response.data
              : "Verifique a chave de acesso.";
          this.$notify({
            group: "geral",
            type: "error",
            title: "Ops!",
            text: msg
          });
          this.$router.push({ path: "/" });
        });
      }
    }
  }
};
</script>
<style lang="scss">
.wbs-login {
  background-color: #e3e3e3;
  width: 100%;
  height: auto;
  min-height: 100%;
  overflow-x: hidden;

  @include element("form") {
    width: 320px;
    height: 75%;
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  & .card-header {
    background: #fff;
    color: #2d7052;
    font-weight: 800;
    padding: 20px 10px 10px 10px;
    border-bottom: none;
  }
}
</style>
